
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/happycustomers",
      function () {
        return require("private-next-pages/happycustomers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/happycustomers"])
      });
    }
  